export class DefaultArchiveTemplate {
    constructor() {
        if (jQuery(".post-type-archive-hora_event").length === 0) {
            return;
        }
        if (jQuery(".event-archive-container.layout-default").length === 0) {
            return;
        }
        this.bindEvents();
    }
    bindEvents() {
        jQuery(document).on("click", ".event-archive-container.layout-default .event-archive-load-more", this._defaultAjaxPagination);
        jQuery(document).on("click", ".event-archive-container.layout-default .event-archive-load-more-past", this._defaultPastAjaxPagination);
    }
    _defaultPastAjaxPagination(e) {
        e.preventDefault();
        const $this = jQuery(this);
        const $container = $this.siblings(".event-archive-past-events-list");
        const currentPage = parseInt($this.data("current-page"), 10);
        const postsPerPage = parseInt($this.data("per-pages"), 10) || 10;
        $this.attr("disabled", "disabled");
        if (isNaN(currentPage)) {
            console.error("Current page is not a valid number.");
            $this.removeAttr("disabled");
            return;
        }
        jQuery
            .ajax({
            url: window.hora_events.ajax_url,
            type: "GET",
            data: {
                action: "hora_events_load_more_past",
                per_page: postsPerPage,
                page: currentPage + 1,
                nonce: window.hora_events.nonce,
                is_past: true,
            },
            success: function (response) {
                if (response.success) {
                    const { events, message, has_more } = response.data;
                    if (events && events.length > 0) {
                        $container.append(events);
                        if (has_more) {
                            $this.data("current-page", currentPage + 1);
                        }
                        else {
                            $this.hide();
                        }
                    }
                    console.log(message);
                }
                else {
                    console.error("Error loading more past events:", response.data);
                }
            },
        })
            .fail(function (xhr, status, error) {
            console.error("AJAX request failed:", status, error);
            alert("An error occurred while loading more past events. Please try again later.");
        })
            .done(function () {
            $this.removeAttr("disabled");
        });
    }
    _defaultAjaxPagination(e) {
        e.preventDefault();
        const $this = jQuery(this);
        const $container = $this.siblings(".event-archive-card-list");
        const currentPage = parseInt($this.data("current-page"), 10);
        $this.attr("disabled", "disabled");
        if (isNaN(currentPage)) {
            console.error("Current page is not a valid number.");
            $this.removeAttr("disabled");
            return;
        }
        jQuery
            .ajax({
            url: window.hora_events.ajax_url,
            type: "GET",
            data: {
                action: "hora_events_load_more",
                page: currentPage + 1,
                nonce: window.hora_events.nonce,
            },
            success: function (response) {
                if (response.success) {
                    const { events, message, has_more } = response.data;
                    if (events && events.length > 0) {
                        $container.append(events);
                        if (has_more) {
                            $this.data("current-page", currentPage + 1);
                        }
                        else {
                            $this.hide();
                        }
                    }
                    console.log(message);
                }
                else {
                    console.error("Error loading more events:", response.data);
                }
            },
        })
            .fail(function (xhr, status, error) {
            console.error("AJAX request failed:", status, error);
            alert("An error occurred while loading more events. Please try again later.");
        })
            .done(function () {
            $this.removeAttr("disabled");
        });
    }
}
